"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTheme = void 0;

var _tokens = require("@dentsu-ui/tokens");

var StyledTheme = {
  background: _tokens.ColorWhite,
  textColor: _tokens.ColorGrey,
  fontSize: _tokens.FontSize11,
  crosshair: {
    line: {
      stroke: _tokens.ColorN600,
      strokeWidth: 1,
      strokeOpacity: 1,
      strokeDasharray: 'none'
    }
  },
  labels: {
    link: {
      color: _tokens.ColorN300
    }
  },
  legends: {
    text: {
      fill: _tokens.ColorGrey,
      fontSize: _tokens.FontSize11,
      fontFamily: _tokens.FontFamilySans,
      fontWeight: _tokens.FontWeightRegular
    }
  },
  axis: {
    legend: {
      text: {
        fill: _tokens.ColorBlack,
        fontSize: _tokens.FontSize11,
        fontFamily: _tokens.FontFamilySans,
        fontWeight: _tokens.FontWeightRegular
      }
    },
    domain: {
      line: {
        stroke: _tokens.ColorN250,
        strokeWidth: 1
      }
    },
    ticks: {
      line: {
        stroke: _tokens.ColorGrey,
        strokeWidth: 0
      },
      text: {
        fill: _tokens.ColorGrey,
        fontSize: _tokens.FontSize11,
        fontFamily: _tokens.FontFamilySans,
        fontWeight: _tokens.FontWeightRegular
      }
    }
  },
  grid: {
    line: {
      stroke: _tokens.ColorN150,
      strokeWidth: 1
    }
  },
  tooltip: {
    container: {
      borderRadius: 15,
      padding: 13,
      fontSize: _tokens.FontSize12,
      boxShadow: _tokens.Shadow8,
      background: _tokens.ColorWhite
    }
  },
  radialGauge: {
    colors: {
      datum: _tokens.ColorB300,
      empty: _tokens.ColorN250
    }
  },
  multiRadialGauge: {
    colors: {
      datum: [_tokens.ColorB300, _tokens.ColorP350],
      empty: _tokens.ColorN250
    }
  }
};
exports.StyledTheme = StyledTheme;